import React from 'react';
import { User, CircleDot, Move, Activity, Dumbbell, Circle } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { conditions } from '../data/mock';

const iconMap = {
  User: User,
  CircleDot: CircleDot,
  Move: Move,
  Activity: Activity,
  Dumbbell: Dumbbell,
  Circle: Circle
};

const Conditions = () => {
  return (
    <section id="conditions" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Conditions We Treat
          </h2>
          <p className="text-xl text-gray-600">
            Expert regenerative medicine care for a wide range of pain conditions
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {conditions.map((condition, index) => {
            const IconComponent = iconMap[condition.icon];
            return (
              <Card 
                key={index}
                className="group hover:shadow-xl transition-all duration-300 border-gray-200 hover:border-[#E63946] cursor-pointer bg-white text-center"
              >
                <CardContent className="p-6">
                  <div className="bg-gradient-to-br from-[#20B2AA]/10 to-[#E63946]/10 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:from-[#E63946] group-hover:to-[#D32F3D] transition-all">
                    <IconComponent className="h-9 w-9 text-[#1B1B3A] group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="font-bold text-gray-900 group-hover:text-[#E63946] transition-colors mb-2">
                    {condition.name}
                  </h3>
                  <p className="text-xs text-[#20B2AA] font-semibold">
                    {condition.treatedCount}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Conditions;
